import { useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { uiActions } from "../store/ui/ui-slice";

const GetLocalStorage = () => {
  const dispatch = useDispatch();
  const token = useSelector((state) => state.user?.token);

  useEffect(() => {
    dispatch(uiActions.setLoading(false));
    dispatch(uiActions.setFormSubmitLoading(false));
  }, [dispatch]);

  if (!token) {
    return <Outlet />;
  }

  return <Navigate to="/live-market" />;
};

export default GetLocalStorage;
